<div *ngIf="isBackOffice"
     class="row margin-h margin-v-l">
  <button type="submit"
          class="button info margin-r-xs border-radius-xlarge cell auto"
          (click)="openNewEvent()">
    {{'news.event.add-event' | translate}}
  </button>
</div>

<div *ngIf="agendaEventsByDate && locale"
     class="hds-list collapsed margin-h-s">
  <div class="hds-list-item cursor-hover border-t-reset">
    <div *ngFor="let agendaEventByDate of agendaEventsByDate | keyvalue: compareAgendaEventKeyDate">
      <app-event [eventDate]="agendaEventByDate.key"
                 [events]="agendaEventByDate.value"
                 [locale]="locale"
                 [isBackOffice]="isBackOffice"
                 (updateEvent)="updateEvents()">
      </app-event>

    </div>
    <div *ngIf="isAnyNextEvent()">
      <div class="grid-x">
        <div class="cell auto">
          <div class="margin-t-s margin-b-s"
               style="font-weight: 500; font-size: 1.3rem; line-height: 24px; color: #37404E;">
            {{'news.event.next-event' | translate}}
          </div>
        </div>
      </div>
      <ul class="hds-accordion" data-accordion="" role="tablist" data-multi-expand="true" data-allow-all-closed="true"
          appFoundation>
        <li class="hds-accordion-item" data-accordion-item="" role="tab"
            *ngFor="let agendaEventByYearMonthAndDate of agendaEventsByYearMonth | keyvalue: getComparatorThatKeepOriginalOrderForMap;">
          <a class="hds-accordion-title" role="tab" aria-expanded="false" aria-selected="false">
            <span class="title">{{accordionTitleMonthYear(agendaEventByYearMonthAndDate.key)}}</span>
            <span class="hds-chip small condensed filter rounded">
            {{quantityOfEventForYearAndMonth(agendaEventByYearMonthAndDate.value.keys())}}
          </span>
          </a>
          <div class="hds-accordion-content" data-tab-content="" role="tabpanel">
            <div *ngFor="let agendaEventByDate of agendaEventByYearMonthAndDate.value | keyvalue: getComparatorThatKeepOriginalOrderForMap;">
              <app-event [eventDate]="agendaEventByDate.key"
                         [events]="agendaEventByDate.value"
                         [locale]="locale"
                         [isBackOffice]="isBackOffice"
                         (updateEvent)="updateEvents()">
              </app-event>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-container *ngIf="eventAvailable; else load">
  <div class="d-block text-center">

    <ng-container *ngIf="!agendaEventsByDate">
      <h2 class="margin-b-s">{{'news.event.error' | translate}}</h2>
      <em class="fal fa-2x fa-exclamation-circle"></em>
    </ng-container>

    <ng-container *ngIf="agendaEventsByDate && agendaEventsByDate.size === 0">
      <h2 class="margin-b-s">{{'news.event.no-event' | translate}}</h2>
      <em class="fal fa-2x fa-info-circle"></em>
    </ng-container>

  </div>
</ng-container>

<ng-template #load>
  <div class="d-block text-center">
    <span class="widget-spinner padding-v-l"></span>
  </div>
</ng-template>
